<template>
  <div id="app">
    <LoaderItem v-if="this.loader"/>

    <div class="container">
      <div class="sidebar-column">
        <div class="sidebar">
          <ul class="breadcrumb">
            <li><a href="/">Home</a></li>
            <li>Products</li>
          </ul>
          <div class="sidebar-filter">
            <div class="filter-mobile-title">Filter products by:</div>

            <div class="promo-check-wrapper">
              <input class="styled-checkbox" :id="'styled-checkbox-promo'"
                     type="checkbox"
                     v-model="initPromo"
                     @change="getPromotions"
              >
              <label :for="'styled-checkbox-promo'"><span>Promotions</span></label>
            </div>

            <div v-for="(filter, index) in filters" :key="index">
              <LeftFilter
                v-bind:filter="filter"
                v-bind:index="index"
                v-bind:unsetFilter="unsetFilter"
                ref="leftFilterChild"
                @interface="handleFcAfterDateBack"
                @loadData="leftFilterLoad"

              />
            </div>

          </div>
        </div>
      </div>
      <div class="main-column">
        <div class="listing-top-bar">
          <div class="results">
            <div class="results-text">Product results:</div>
            <div class="results-value">
              <span>{{ currentPage == 1 ? 1 : (countProducts * currentPage) - 5 }} to {{ currentPage == pagesCount ? totalProducts : (countProducts * currentPage) }}</span>
              of <span>{{ totalProducts }}</span></div>
          </div>
          <div class="products-sorting">
            <span class="sort">Sort by:</span>
            <div class="sort-dropdown">
              <select id="sort-select" class="select-hidden">
                <option v-for="orderbyValue in orderby" v-bind:value="orderbyValue.value">{{ orderbyValue.title }}
                </option>
              </select>
            </div>
            <!--{{currentSort}}-->

          </div>
        </div>
        <ul class="selected-filters">
          <li v-for="filterValue in select_filters"><span v-html="filterValue.name"></span><span class="close"
                                                                                                 @click="onRemoveFilter(filterValue)"></span>
          </li>
          <li v-if="this.$route.query.s"><span v-html="'Search by: '+this.$route.query.s"></span>
            <span class="close" @click="onRemoveFilter(true, 'search')"></span>
          </li>
          <li v-if="this.$store.getters.get_selected_filters.length > 0 || this.$route.query.s"
              @click="onRemoveFilter(true, 'all')">CLEAR ALL FILTERS
          </li>
        </ul>


        <ul class="listing-list">
          <template v-for="(product, index) in products">
            <ProductItem
              v-bind:product="product"
              v-bind:index="index"
            />
          </template>
        </ul>


        <div class="pager-wrapper">
          <paginate v-if="pagesCount > 1"
                    :page-count="pagesCount"
                    :click-handler="changePage"
                    :prev-text="''"
                    :next-text="''"
                    :breac-view-text="'...'"
                    :active-class="'active'"
                    :next-link-class="'next'+(pagesCount == currentPage ? ' disabled' : '')"
                    :prev-link-class="'prev'+(currentPage == 1 ? ' disabled' : '')"
                    :break-view-link-class="'more'"
                    :container-class="'pager'">
          </paginate>
        </div>
      </div>
    </div>

    <AddCartItem v-if="this.addToCart"/>

  </div>
</template>

<script>
import LoaderItem from './components/LoaderItem'
import AddCartItem from './components/product/AddToCart'
import ProductItem from './components/product/ProductItem'
import LeftFilter from './components/product/LeftFilter'

export default {
  name: 'app',
  components: {AddCartItem, LoaderItem, ProductItem, LeftFilter},
  comments: [AddCartItem, LoaderItem, ProductItem, LeftFilter],

  computed: {
    addToCart() {
      return this.$store.state.addToCart.show
    },

    loader() {
      return this.$store.state.loader
    },

    products() {
      return this.$store.state.products.products
    },
    countProducts() {
      return this.$store.state.products.products_count;
    },
    totalProducts() {
      return this.$store.state.products.found_products;
    },
    pagesCount() {
      return this.$store.state.products.max_num_pages
    },

    select_filters() {
      return this.$store.getters.get_selected_filters;
    },

    filters() {
      return this.$store.state.filters;
    },

    orderby() {
      return this.$store.state.orderby;
    },

    promo() {
      return this.$store.state.promo;
    },

    currentPage() {
      return this.$store.state.currentPage;
    },

    currentOrderby() {
      return this.$store.state.currentOrderby;
    },
  },
  data() {
    return {
      orderbyInit: false,
      initPromo: false,
      unsetFilter: false,
      filterLoaded: 0,
    }
  },

  methods: {
    handleFcAfterDateBack(event) {
      this.unsetFilter = false;
      // console.log('data after child handle: ', event) // get the data after child dealing
    },

    onChangeOrderby(value, order = false) {
      this.$store.commit('SET_SORT', {value: value, order: order});
      this.$store.dispatch('getProducts');

    },

    changePage: function (pageNum) {
      this.$store.commit('SET_LOADER', true);

      this.$store.commit('SET_CURR_PAGE', pageNum);
      this.$store.dispatch('getProducts');

    },

    onRemoveFilter: function (filterValue, type = null) {

      if (type === 'search') {
        this.$store.commit('SET_SEARCH', '');
      } else {
        this.unsetFilter = filterValue;
        // this.$router.push({query: ''});
        this.$store.commit('UNSET_FILTERS', filterValue);
      }

      this.$store.commit('SET_CURR_PAGE', 1);
      this.$store.commit('SET_LOADER', true);

      var query = this.$store.state.filters.reduce(
        (obj, cat) => {
          return Object.assign(
            obj,
            {
              [cat.slug] : this.$store.getters.get_filters(cat.slug).join(','),
            }
          )
        }
        , {}
      );

      if(type !== 'search') {
        if (this.$route.query.s) {
          Object.assign(query, {s: this.$route.query.s});
          this.$store.commit('SET_SEARCH', this.$route.query.s);
        }
      }

      if(this.$route.query.promo !== undefined) {
        var promo = JSON.parse(this.$route.query.promo);
        if (promo === true) {
          Object.assign(query, {promo: promo});
        }
      }

      this.$router.push({query: query});

      this.$store.commit('SET_CURR_PAGE', 1);

      this.$store.dispatch('getProducts');
    },

    getPromotions : function( e ) {
      this.$store.commit('SET_LOADER', true);

      var query = this.$store.state.filters.reduce(
        (obj, cat) => {
          return Object.assign(
            obj,
            {
              [cat.slug] : this.$store.getters.get_filters(cat.slug).join(','),
            }
          )
        }
        , {}
      );

      if(this.$route.query.s) {
        Object.assign(query, {s: this.$route.query.s});
        this.$store.commit('SET_SEARCH', this.$route.query.s);
      }

      this.$store.commit('SET_PROMO', this.initPromo);
      Object.assign(query, {promo: this.initPromo});

      this.$router.push({query: query});

      this.$store.commit('SET_CURR_PAGE', 1);
      this.$store.dispatch('getProducts');
    },

    leftFilterLoad : function() {
      this.filterLoaded = this.filterLoaded+1;
      if(this.filterLoaded == 3) {
        this.$refs.leftFilterChild[0].onChangeFilter();
        this.filterLoaded = 0;
      }
    },
  },
  mounted() {
    if(this.$route.query.promo !== undefined) {
      var promo = JSON.parse(this.$route.query.promo);
      if(promo === true) {
        this.initPromo = promo;
        this.$store.commit('SET_PROMO', promo);
      }
    }

    if (this.$store.state.filters.length <= 0) {
      this.$store.dispatch('getProducts');
    }
  },

  updated() {
    if (this.orderbyInit == false) {
      jQuery('.select-item').on('click', (evt) => {
        var value = evt.target.getAttribute('rel');
        if (value !== this.currentOrderby) {
          this.onChangeOrderby(value);
        } else {
          this.onChangeOrderby(value, true);
        }
      });
      this.orderbyInit = true;

    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue